import classnames from "classnames";
import React from "react";

// tslint:disable-next-line:no-var-requires
const styles = require("./StatusBarInfoBox.scss");

interface StatusBarInfoBoxProps {
    readonly children: string;
}

export default function StatusBarInfoBox({ children }: StatusBarInfoBoxProps) {
    return (
        <span className={classnames(styles.info)}>
            <span>{children}</span>
        </span>
    );
}
